import Vue from "vue";
import VueCompositionApi from "@vue/composition-api";
import store from "./store";
import router from "./router";
import App from "./App.vue";

// import "@fortawesome/fontawesome-free/js/fontawesome";
// import "@fortawesome/fontawesome-free/js/regular";
// import "@fortawesome/fontawesome-free/js/solid";
// import "@mdi/font/css/materialdesignicons.min.css";
// import Buefy from "buefy";
import {
  //@ts-ignore
  Button,
  //@ts-ignore
  Table,
  //@ts-ignore
  Field,
  //@ts-ignore
  Input,
  //@ts-ignore
  Checkbox,
  //@ts-ignore
  Modal,
  //@ts-ignore
  Tooltip,
  //@ts-ignore
  Slider,
  //@ts-ignore
  Loading,
  //@ts-ignore
  Pagination,
  //@ts-ignore
  Snackbar,
  //@ts-ignore
  Tabs,
  //@ts-ignore
  Select,
  //@ts-ignore
  Numberinput
} from "buefy";
// import "bulma/css/bulma.min.css";
import "buefy/dist/buefy.min.css";
// import "bulma";

Vue.use(VueCompositionApi);

Vue.config.productionTip = false;
// buefy
Vue.use(Button);
Vue.use(Table);
Vue.use(Field);
Vue.use(Input);
Vue.use(Checkbox);
Vue.use(Modal);
Vue.use(Tooltip);
Vue.use(Slider);
Vue.use(Loading);
Vue.use(Pagination);
Vue.use(Snackbar);
Vue.use(Tabs);
Vue.use(Select);
Vue.use(Numberinput);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
